import DriverMigrationDetails from "../../components/DeliveryDrivers/DriverMigrationDetails";
import { getPath, getInitialState } from "../../utils";

const initialState = {
  driversList: [],
  nextPage: -1,
  prevPage: -1,
  driversCount: {},
  driverBasicDetails: {},
  driverFinancialDetails: {},
  driverAdditionalDetails: {},
  driverAssets: [],
  driverStores: [],
  driverReservations: [],
  driverServices: [],
  driverLocalities: [],
  driverLogs: [],
  eligibleServices: {},
  driverDeliveryStatuses: [],
  driverLifecycleStatuses: [],
  driverDeliveryServices: [],
  driverProfessions: [],
  driverEducations: [],
  driverAssignmentStatus: {},
  driverEducationQualifications: [],
  driverBankStatus: {},
  driverActionReasons: [],
  driverDocuments: {},
  driverDocumentId: "",
  driverListFilters: {},
  driverMigrationDetails: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DRIVERS_COUNT":
      return setDriversCount(state, action);
    case "SET_DRIVERS_LIST":
      return setDriversList(state, action);
    case "SET_DRIVER_ASSIGNMENT_STATUS":
      return setDriverAssignmentStatus(state, action);
    case "RESET_STATE_DELIVERY_DRIVERS":
      return resetState(state, action);
    case "RESET_INDIVIDUAL_DRIVER_STATE":
      return resetIndividualDriverState(state, action);
    case "SET_DRIVER_BASIC_DETAILS":
      return setDriverBasicDetails(state, action);
    case "SET_DRIVER_FINANCIAL_DETAILS":
      return setDriverFinancialDetails(state, action);
    case "SET_DRIVER_ADDITIONAL_DETAILS":
      return setDriverAdditionalDetails(state, action);
    case "SET_DRIVER_ASSET_DETAILS":
      return setDriverAssetDetails(state, action);
    case "SET_DRIVER_STORE_MAPPING_DETAILS":
      return setDriverStoreMappingDetails(state, action);
    case "SET_DRIVER_RESERVATION_DETAILS":
      return setDriverReservationDetails(state, action);
    case "SET_DRIVER_SERVICES_DETAILS":
      return setDriverServicesDetails(state, action);
    case "SET_ELIGIBLE_DRIVER_SERVICES":
      return setEligibleDriverServices(state, action);
    case "SET_DRIVER_LOCALITIES_DETAILS":
      return setDriverLocalitiesDetails(state, action);
    case "SET_DRIVER_LOGS_DETAILS":
      return setDriverLogsDetails(state, action);
    case "SET_DRIVER_DELIVERY_STATUSES":
      return setDriverDeliveryStatuses(state, action);
    case "SET_DRIVER_DELIVERY_SERVICES":
      return setDriverDeliveryServices(state, action);
    case "SET_DRIVER_LIFECYCLE_STATUSES":
      return setDriverLifecycleStatuses(state, action);
    case "SET_DRIVER_PROFESSIONS":
      return setDriverProfessions(state, action);
    case "SET_DRIVER_EDUCATIONS":
      return setDriverEducations(state, action);
    case "SET_DRIVER_EDUCATION_QUALIFICATIONS":
      return setDriverEducationQualifications(state, action);
    case "SET_DRIVER_BANK_STATUS":
      return setDriverBankStatus(state, action);
    case "SET_DRIVER_ACTION_REASONS":
      return setDriverActionReasons(state, action);
    case "SET_DRIVER_DOCUMENTS":
      return setDriverDocuments(state, action);
    case "SET_ACTIVE_FILTERS_DELIVERY_DRIVERS":
      return setActiveFiltersDrivers(state, action);
    case "SET_DRIVER_MIGRATION_DETAILS":
        return setDriverMigrationDetails(state, action);
    default:
      return state;
  }
}

const setActiveFiltersDrivers = (state, action) => {
  return {
    ...state,
    driverListFilters: action.payload,
  };
};

const setDriverActionReasons = (state, action) => {
  return {
    ...state,
    driverActionReasons: getPath(action.payload, "reasons", []),
  };
};

const setDriverAssignmentStatus = (state, action) => {
  return {
    ...state,
    driverAssignmentStatus: action.payload || {},
  };
};

const setDriverDocuments = (state, action) => {
  return {
    ...state,
    driverDocuments: getPath(action.payload, "documents", {}),
    driverDocumentId: getPath(action.payload, "id", ""),
  };
};

const setDriverBankStatus = (state, action) => {
  return {
    ...state,
    driverBankStatus: action.payload,
  };
};

const setDriverProfessions = (state, action) => {
  return {
    ...state,
    driverProfessions: getPath(action.payload, "professions", []),
  };
};

const setDriverEducations = (state, action) => {
  return {
    ...state,
    driverEducations: getPath(action.payload, "fields", []),
  };
};

const setDriverEducationQualifications = (state, action) => {
  return {
    ...state,
    driverEducationQualifications: getPath(
      action.payload,
      "qualifications",
      []
    ),
  };
};

const setDriverDeliveryStatuses = (state, action) => {
  return {
    ...state,
    driverDeliveryStatuses: getPath(action.payload, "Statuses", {}),
  };
};

const setDriverLifecycleStatuses = (state, action) => {
  return {
    ...state,
    driverLifecycleStatuses: getPath(action.payload, "Statuses", {}),
  };
};

const setDriverDeliveryServices = (state, action) => {
  return {
    ...state,
    driverDeliveryServices: getPath(action.payload, "Services", {}),
  };
};

const setEligibleDriverServices = (state, action) => {
  return {
    ...state,
    eligibleServices: getPath(action.payload, "services", {}),
  };
};

const setDriverLocalitiesDetails = (state, action) => {
  return {
    ...state,
    driverLocalities: getPath(action.payload, "locality_preferences", []),
  };
};

const setDriverLogsDetails = (state, action) => {
  return {
    ...state,
    driverLogs: getPath(action.payload, "change_logs", []),
  };
};

const setDriverServicesDetails = (state, action) => {
  return {
    ...state,
    driverServices: getPath(action.payload, "services", []),
    driverServicesChangeLog: getPath(action.payload, "change_logs", [])
  };
};

const setDriverReservationDetails = (state, action) => {
  return {
    ...state,
    driverReservations: getPath(action.payload, "reservations", []),
  };
};

const setDriverAssetDetails = (state, action) => {
  return {
    ...state,
    driverAssets: getPath(action.payload, "assets", []),
  };
};

const setDriverStoreMappingDetails = (state, action) => {
  return {
    ...state,
    driverStores: getPath(action.payload, "data", []),
  };
};

const setDriverBasicDetails = (state, action) => {
  return {
    ...state,
    driverBasicDetails: getPath(action.payload, "basic_details", {}),
  };
};

const setDriverFinancialDetails = (state, action) => {
  return {
    ...state,
    driverFinancialDetails: action.payload,
  };
};

const setDriverAdditionalDetails = (state, action) => {
  return {
    ...state,
    driverAdditionalDetails: action.payload,
  };
};

const setDriversCount = (state, action) => {
  return {
    ...state,
    driversCount: action.payload,
  };
};

const setDriversList = (state, action) => {
  return {
    ...state,
    driversList: getPath(action.payload, "drivers", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};


const setDriverMigrationDetails = (state, action) => {
  return {
    ...state,
    driverMigrationDetails: getPath(action.payload, "migration_details", []),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const resetIndividualDriverState = (state, action) => {
  return {
    ...state,
    driverBasicDetails: {},
    driverFinancialDetails: {},
    driverAdditionalDetails: {},
    driverAssets: [],
    driverStores: [],
    driverReservations: [],
    driverServices: [],
    driverMigrationDetails: [],
    driverLocalities: [],
    driverLogs: [],
    eligibleServices: {},
    driverDocuments: {},
    driverDocumentId: "",
    driverAssignmentStatus: {},
  };
};


